import './OrganizerRegistration.css'
import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

import { Header } from '../../components/Header/Header'
import { Input } from '../../components/Input/Input'
import { Button } from '../../components/Button/Button'
import { useRegistrationMutation } from '../../redux/orgCreate/orgCreateApiSlice'

export default function OrganizerRegistration() {
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const [registrationUser] = useRegistrationMutation()
	const navigate = useNavigate()

	const [name, setName] = useState('')
	const [surname, setSurname] = useState('')
	const [email, setEmail] = useState('')
	const [password, setPassword] = useState('')
	const [confirmPassword, setConfirmPassword] = useState('')
	const [isChecked, setIsChecked] = useState(false)

	const [errEmail, setErrEmail] = useState('')
	const [errPassword, setErrPassword] = useState('')
	const [errConfirmPassword, setErrConfirmPassword] = useState('')
	const [errIsChecked, setErrIsChecked] = useState('')

	// Функция для получения имени Организатора
	const handleNameInput = (nameValue) => {
		setName(nameValue)
	}

	// Функция для получения фамилии Организатора
	const handleSurnameInput = (surnameValue) => {
		setSurname(surnameValue)
	}

	// Функция для получения Email Организатора
	const handleEmailInput = (emailValue) => {
		setEmail(emailValue?.replace(' ', ''))
	}
	const handleOnClickEmail = _ => { setErrEmail('') }

	// Функция для получения пароля Организатора
	const handlePasswordInput = (passwordValue) => {
		setPassword(passwordValue?.replace(' ', ''))
	}
	const handleOnClickPassword = _ => { setErrPassword('') }

	// Функция для получения пароля ещё раз Организатора
	const handleConfirmPasswordInput = (confirmPasswordValue) => {
		setConfirmPassword(confirmPasswordValue?.replace(' ', ''))
	}
	const handleOnClickConfirmPassword = _ => { setErrConfirmPassword('') }

	const handleCheckboxChange = _ => {
		setIsChecked(!isChecked)
	}
	const handleOnClickIsChecked = _ => { setErrIsChecked('') }

	const checkFields = _ => {
		let errEmailBool = false
		let errPasswordBool = false
		let errConfirmPasswordBool = false
		let errEqualConfirmPasswordBool = false
		let errIsCheckedBool = false

		// Валидация Email
		if (email?.length === 0) {
			setErrEmail(t('Enter Email'))
			errEmailBool = true
		} else {
			const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{1,}$/i

			if (emailRegex.test(email)) {
				errEmailBool = false
			} else {
				setErrEmail(t('Invalid email'))
				errEmailBool = true
			}
		}

		// Валидация Password
		if (password?.length === 0) {
			setErrPassword(t('Enter password'))
			errPasswordBool = true
		} else {
			errPasswordBool = false
		}

		// Валидация ConfirmPassword
		if (confirmPassword?.length === 0) {
			setErrConfirmPassword(t('Enter password'))
			errConfirmPasswordBool = true
		} else {
			errConfirmPasswordBool = false
		}

		// Валидация на соотвествие Password и ConfirmPassword
		if (password !== confirmPassword) {
			setErrConfirmPassword(t('Password mismatch'))
			errEqualConfirmPasswordBool = true
		} else {
			errEqualConfirmPasswordBool = false
		}

		// Валидация IsChecked
		if (isChecked) {
			setErrIsChecked(t(''))
			errIsCheckedBool = false
		} else {
			setErrIsChecked(t('Confirm your consent to the processing of personal data'))
			errIsCheckedBool = true
		}

		if (errEmailBool || errPasswordBool || errConfirmPasswordBool || errEqualConfirmPasswordBool || errIsCheckedBool) {
			return false
		}

		return true
	}

	// Проверяем и отправляем данные на сервер
	const handleSubmit = async (event) => {
		event.preventDefault()

		if (!checkFields()) {
			return
		}

		let body

		try {
			body = { first_name: name, last_name: surname, email: email, password: password }
			const response = await registrationUser(body).unwrap()

			if (response?.error) {
				return
			}

			navigate('/login')
		} catch (e) {
			// setErrPassword(t('Incorrect password'))
			setErrEmail(body?.email && t('There is already an account for this email'))

			console.log('Registration catch error', e)
		}
	}

	return (
		<>
			<Header
				className="header-container"
				title={t('Registration')}
				backButton={true}
			/>

			<div className="registration__container">
				<form className="registration__form" onSubmit={handleSubmit} noValidate>
					<div className="registration__form-input">
						<label className="registration__input-label" htmlFor="registration">
							{t('Player name')}
						</label>

						<div className="registration__input-name">
							<Input
								value={name}
								onChange={(e) => handleNameInput(e.target.value)}
								type={'text'}
								required={false}
							/>
						</div>
					</div>

					<div className="registration__form-input">
						<label className="registration__input-label" htmlFor="registration">
							{t('Last name')}
						</label>

						<div className="registration__input-name">
							<Input
								value={surname}
								onChange={(e) => handleSurnameInput(e.target.value)}
								type={'text'}
								required={false}
							/>
						</div>
					</div>

					<div className="registration__form-input">
						<label className="registration__input-label" htmlFor="registration">
							{t('Email')} <span style={{ color: 'red' }}>*</span>
						</label>

						<div className="registration__input-name">
							<Input
								value={email}
								onChange={(e) => handleEmailInput(e.target.value)}
								onClick={handleOnClickEmail}
								type={'text'}
								borderColor={errEmail ? '#F20505' : ''}
								required={false}
							/>
						</div>

						{
							errEmail &&
								<p className="registration__error">
									{ errEmail }
								</p>
						}
					</div>

					<div className="registration__form-input">
						<label className="registration__input-label" htmlFor="registration">
							{t('Password')} <span style={{ color: 'red' }}>*</span>
						</label>

						<div className="registration__input-name">
							<Input
								value={password}
								onChange={(e) => handlePasswordInput(e.target.value)}
								onClick={handleOnClickPassword}
								type={'password'}
								borderColor={errPassword ? '#F20505' : ''}
								required={false}
								maxLength={'15'}
							/>
						</div>

						{
							errPassword &&
								<p className="registration__error">
									{ errPassword }
								</p>
						}
					</div>

					<div className="registration__form-input">
						<label className="registration__input-label" htmlFor="registration">
							{t('Confirm password')} <span style={{ color: 'red' }}>*</span>
						</label>

						<div className="registration__input-name">
							<Input
								value={confirmPassword}
								onChange={(e) => handleConfirmPasswordInput(e.target.value)}
								onClick={handleOnClickConfirmPassword}
								type={'password'}
								borderColor={errConfirmPassword ? '#F20505' : ''}
								required={false}
							/>
						</div>

						{
							errConfirmPassword &&
								<p className="registration__error">
									{ errConfirmPassword }
								</p>
						}
					</div>

					<div className="registration__form-input">
						<div className="checkbox-container">
							<input
								type="checkbox"
								className="checkbox-input"
								checked={isChecked}
								onChange={(e) => handleCheckboxChange(e.target.value)}
								onClick={handleOnClickIsChecked}
								id="registration"
							/>

							<label className="registration__input-label" htmlFor="registration">
								{t('I agree to the processing of personal data')}
							</label>
						</div>

						{
							errIsChecked &&
								<p className="registration__error">
									{ errIsChecked }
								</p>
						}
					</div>

					<div className="login_button-submit">
						<Button title={t('Register')} />
					</div>
				</form>
			</div>
		</>
	)
}